import { cn } from '@/lib/utils';

interface BetaBadgeProps {
  className?: string;
  variant?: 'default' | 'subtle' | 'inverted';
}

/**
 * Small "Beta" tag used across the app to flag that the product is still in beta.
 */
export function BetaBadge({ className, variant = 'default' }: BetaBadgeProps) {
  const styles = {
    default:
      'bg-primary/10 text-primary border border-primary/20',
    subtle:
      'bg-muted text-muted-foreground border border-border',
    inverted:
      'bg-white/15 text-white border border-white/20 backdrop-blur',
  }[variant];

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide leading-none',
        styles,
        className,
      )}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      Beta
    </span>
  );
}
